import logo_petroprix from "../../assets/images/logo-petroprix.svg";

export const LogoPetroprix = () => {
  return (
    <img src={logo_petroprix} alt="logo_petroprix" style={{ width: "1.5em" }} />
  );
};
